/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data ids used in the event subscription delete form.
 * @export
 */
export const EVENT_SUBSCRIPTION_DELETE_DATA_IDS = {
  cancelButton: `Button: Close the event subscription delete form dialog`,
  deleteButton: `Button: Confirm event subscription delete form dialog`,
  deleteErrorMessage: `Error message: Delete event subscription error`,
};
